export const actionKey = '@@config';
export const reduxKey = '@@config';

//# sourceMappingURL=constants.js.map